import { Card, CardHeader, CardBody, CardFooter, Body, Grid, Button, DynamicIcon, Caption, Image, Avatar, Anchor, Divider, Heading, Table, TableRow, TableHead, TableCell, TableBody, HeadCell, AspectRatio } from 'legion-ui';
import * as React from 'react';
export default {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Body,
  Grid,
  Button,
  DynamicIcon,
  Caption,
  Image,
  Avatar,
  Anchor,
  Divider,
  Heading,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  HeadCell,
  AspectRatio,
  React
};